import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a8ecd45&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a8ecd45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ecd45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8ecd45')) {
      api.createRecord('4a8ecd45', component.options)
    } else {
      api.reload('4a8ecd45', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a8ecd45&scoped=true&", function () {
      api.rerender('4a8ecd45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Broadcast/Mobile/components/ListCard/index.vue"
export default component.exports